import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

/**
 * POST /azureExport/export - export issues for date range, returns xlsx file or JSON message
 * @param {string} startDate - YYYY-MM-DD
 * @param {string} endDate - YYYY-MM-DD
 * @returns {Promise<{ blob: Blob, isJson: boolean }>} - blob and whether response is JSON (e.g. "no issues")
 */
export const azureExportExport = async (startDate, endDate) => {
  try {
    const response = await apiClient.post(
      '/azureExport/export',
      { start_date: startDate, end_date: endDate },
      {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        },
      }
    );
    const contentType = response.headers?.['content-type'] || '';
    const isJson = contentType.toLowerCase().includes('application/json');
    return { blob: response.data, isJson };
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
